import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Page_Login from  '../pages/Page_Login'
import Page_Manage from '../pages/Page_Manage'
Vue.use(Router);

const routes = [
  {
    // 默认路由
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: '/login',
    component: Page_Login
  },{
    path: '/page_manage',
    name: '/page_manage',
    component: Page_Manage
  }
]

const router = new Router({
  // base: "/drumsky_admin/",  // 前缀名  可以不要  但看起来会好点 知道是什么项目
  base: "/",  // 生产
  mode:'history', //跳转时不带#  默认时 hash 路径带# ，微信授权登陆回调对#支持不友好，所以我们把路由换成history模式，后台配合改一下，不然页面会404。
  routes
})

router.beforeEach((to, from, next) => {
  // store.changeTabBar({name: to.meta.tabBar, show: to.meta.showTabBar})
  // document.title = to.meta.title
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js